import React from 'react';
import { X, Users as UsersIcon } from 'lucide-react';
import { User } from '../types';

interface UsersListProps {
  users: User[];
  onClose: () => void;
}

const UsersList: React.FC<UsersListProps> = ({ users, onClose }) => {
  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4 text-center">
        {/* Background overlay */}
        <div 
          className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75"
          onClick={onClose}
        />
        
        {/* Modal */}
        <div className="inline-block align-middle bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all max-w-md w-full">
          <div className="bg-white px-4 pt-5 pb-4">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center">
                <UsersIcon className="h-5 w-5 text-blue-600 mr-2" />
                <h3 className="text-lg font-medium text-gray-900">
                  Active Users ({users.length})
                </h3>
              </div>
              <button
                onClick={onClose}
                className="text-gray-400 hover:text-gray-600 transition-colors"
              >
                <X className="h-5 w-5" />
              </button>
            </div>
            
            <div className="space-y-3 max-h-60 overflow-y-auto">
              {users.map((user) => (
                <div 
                  key={user.id || user.name} 
                  className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg"
                >
                  <div 
                    className="w-8 h-8 rounded-full flex items-center justify-center text-white text-sm font-medium"
                    style={{ backgroundColor: user.color }}
                  >
                    {(user.name || 'A')[0].toUpperCase()}
                  </div>
                  <div className="flex-1">
                    <p className="text-sm font-medium text-gray-900">
                      {user.name}
                    </p>
                    <p className="text-xs text-gray-500">
                      {user.isAnonymous ? 'Anonymous' : 'Named user'}
                    </p>
                  </div>
                  <div className="w-2 h-2 bg-green-400 rounded-full" title="Online" />
                </div>
              ))}
              
              {users.length === 0 && (
                <div className="text-center py-6 text-gray-500">
                  <UsersIcon className="h-8 w-8 mx-auto mb-2 text-gray-300" />
                  <p className="text-sm">No users connected</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UsersList;